import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  position: relative;
  background-color: rgb(0, 0, 0, 0.7);

  .exit-icon {
    position: absolute;
    width: 50px;
    height: 50px;
    z-index: 99;
    top: 20px;
    right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const StageContainer = styled.div`
  width: 596px;
  height: 894px;
  background: white;
  margin: 2.5rem 2rem;
`;
